document.addEventListener("DOMContentLoaded", () => {
  if (!document.body.classList.contains('logged-in')) {
    // User not logged in - force zero counters and skip logic
    const wishlistCountEl = document.getElementById('wishlist-count-display');
    const cartCountEl = document.getElementById('course-cart-count');
    if (wishlistCountEl) wishlistCountEl.textContent = '0';
    if (cartCountEl) cartCountEl.textContent = '0';
    return; // stop further processing
  }

  // === Logged in user logic ===
  // CART

  const cartKey = 'tutor_cart_courses';

  function getCart() {
    return JSON.parse(localStorage.getItem(cartKey) || '[]');
  }

  function saveCart(items) {
    localStorage.setItem(cartKey, JSON.stringify(items));
  }

  function updateCartCount() {
    const count = getCart().length;
    const countEl = document.getElementById('course-cart-count');

    if (countEl) {
      countEl.textContent = count;

      if (count > 0) {
        countEl.classList.remove('cart-bounce'); 
        void countEl.offsetWidth; 
        countEl.classList.add('cart-bounce');
      } else {
        countEl.classList.remove('cart-bounce'); 
      }
    }
  }

  function addToCart(courseId) {
    const cart = getCart();
    if (!cart.includes(courseId)) {
      cart.push(courseId);
      saveCart(cart);
      updateCartCount();
    }
  }

  function removeFromCart(courseId) {
    let cart = getCart();
    cart = cart.filter(id => id !== courseId);
    saveCart(cart);
    updateCartCount();
  }

  document.body.addEventListener('click', e => {
    const addBtn = e.target.closest('.tutor-native-add-to-cart');
    if (addBtn) {
      const courseId = addBtn.getAttribute('data-course-id');
      if (courseId) addToCart(courseId);
      return;
    }

    const removeBtn = e.target.closest('.tutor-cart-remove-button');
    if (removeBtn) {
      const courseId = removeBtn.getAttribute('data-course-id');
      if (courseId) removeFromCart(courseId);
      return;
    }
  });

  updateCartCount();

  // WISHLIST - jQuery part

  const $wishlistCountDisplay = jQuery('#wishlist-count-display');

  let wishlistCount = parseInt(localStorage.getItem('wishlistCount')) || 0;

  const isWishlistPage = jQuery('.tutor-dashboard-content-inner.my-wishlist').length > 0;
  if (isWishlistPage) {
    wishlistCount = jQuery('.tutor-dashboard-content-inner.my-wishlist .tutor-course-wishlist-btn').length;
    localStorage.setItem('wishlistCount', wishlistCount);
  }

  $wishlistCountDisplay.text(wishlistCount);

  jQuery(document).on('click', '.tutor-course-wishlist-btn', function(e) {
    e.preventDefault();

    const $btn = jQuery(this);

    if (!$btn.hasClass('wishlisted')) {
      $btn.addClass('wishlisted');
      wishlistCount++;
    } else {
      $btn.removeClass('wishlisted');
      wishlistCount = Math.max(0, wishlistCount - 1);
    }

    localStorage.setItem('wishlistCount', wishlistCount);
    $wishlistCountDisplay.text(wishlistCount);
  });
});


  jQuery(document).ready(function () {
    let counterStarted = false;

    function startCounter() {
      jQuery('.counter').each(function () {
        jQuery(this).prop('Counter', 0).animate({
          Counter: jQuery(this).text()
        }, {
          duration: 1000,
          easing: 'swing',
          step: function (now) {
            $(this).text(Math.ceil(now));
          }
        });
      });
    }

    const observer = new IntersectionObserver(function (entries, observer) {
      entries.forEach(entry => {
        if (entry.isIntersecting && !counterStarted) {
          counterStarted = true;
          startCounter();
          observer.unobserve(entry.target); // Optional: stop observing once triggered
        }
      });
    }, {
      threshold: 0.5 // Adjust as needed (e.g., 0.5 = 50% in view)
    });

    const counterSection = document.querySelector('.benefit_wrapper');
    if (counterSection) {
      observer.observe(counterSection);
    }
  });

  jQuery(window).on("load", function(){
      $('.preloader').fadeOut(); 
  })


  jQuery('.hamburger').click(function() {
  jQuery( this ).toggleClass( "active" );
});


const body = document.querySelector("body"),
  navBar = document.querySelector("nav"),
  menuBtns = document.querySelectorAll(".menu-icon"),
  hamburger = document.querySelector(".hamburger"),
  overlay = document.querySelector(".overlay"),
  modeSwitch = body.querySelector(".toggle-switch"),
  modeText = body.querySelector(".mode-text");

menuBtns.forEach((menuBtn) => {
  menuBtn.addEventListener("click", () => {
    navBar.classList.toggle("open");
  });
});

hamburger.addEventListener("click", (e) => {
  e.preventDefault(); 
  navBar.classList.toggle("open");
});

overlay.addEventListener("click", () => {
  navBar.classList.remove("open");
  hamburger.classList.remove('active');
});


modeSwitch.addEventListener("click", () => {
  body.classList.toggle("dark");

  if (body.classList.contains("dark")) {
    modeText.innerText = "Light mode";
  } else {
    modeText.innerText = "Dark mode";
  }
});
